import actionCreatorFactory from 'typescript-fsa';

const ac = actionCreatorFactory('[error]');
export const errorActions = {
  showError: ac<any>('showError'),
  throwError: ac('throwError'),
};
